import BaseModel from './BaseModel';
import { db } from '../utilities';
import { collection, doc, query, where, getDocs, addDoc, updateDoc } from 'firebase/firestore';

export default class SpecialAccess extends BaseModel {
  constructor() {
    super(collection(db, 'special_access'));
  }

  static async add(data: any) {
    try {
      const docRef = await addDoc(collection(db, 'special_access'), data);
      return { id: docRef.id, ...data };
    } catch (error) {
      console.error('Error adding special access data:', error);
      throw new Error('Failed to add special access data');
    }
  }

  static async getAll() {
    try {
      const snapshot = await getDocs(collection(db, 'special_access'));
      return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    } catch (error) {
      console.error('Error getting special access data:', error);
      throw new Error('Failed to retrieve special access data');
    }
  }

  static async updateStatus(specialurl: any, newStatus: any) {
    try {
      const snapshot = await getDocs(
        query(collection(db, 'special_access'), where('specialurl', '==', specialurl))
      );
      if (!snapshot.empty) {
        await updateDoc(snapshot.docs[0].ref, { status: newStatus });
        return { success: true };
      } else {
        throw new Error('No matching document found');
      }
    } catch (error) {
      console.error('Error updating special access status:', error);
      throw new Error('Failed to update special access status');
    }
  }

  static async getByFormId(formId: string) {
    try {
      const snapshot = await getDocs(
        query(collection(db, 'special_access'), where('formid', '==', formId))
      );
      return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    } catch (error) {
      console.error('Error querying special access records:', error);
      throw new Error('Failed to query special access records');
    }
  }

  static async disableRecord(recordId: string) {
    try {
      await updateDoc(doc(db, 'special_access', recordId), { status: 'disabled' });
    } catch (error) {
      console.error('Error disabling special access record:', error);
      throw new Error('Failed to disable special access record');
    }
  }

  static async enableRecord(recordId: string) {
    try {
      await updateDoc(doc(db, 'special_access', recordId), { status: 'new' });
    } catch (error) {
      console.error('Error enabling special access record:', error);
      throw new Error('Failed to enable special access record');
    }
  }
}
